import { LoadingButton } from "@bvhi/ui-base";
import { UpdateIcon } from "@bvhi/ui-icons";
import { useTranslation } from "react-i18next";

interface Props {
  disabled?: boolean;
  requestActive: boolean;
  entityLabel: string;
  renderLabelAsString?: boolean;
}

export const FormUpdateLoadingButton = ({ disabled = false, requestActive, entityLabel, renderLabelAsString }: Props) => {
  const { t } = useTranslation(["common"]);

  return (
    <LoadingButton disabled={disabled} loading={requestActive} startIcon={<UpdateIcon />} type="submit">
      {renderLabelAsString ? entityLabel : t("common:form.button.update", { value: entityLabel })}
    </LoadingButton>
  );
};
